import { Component, OnInit } from '@angular/core';
import { settings } from '../../../shared/constants/settings';
import { ListComponent } from '../list.component';

@Component({
  selector: 'app-list-mobile',
  templateUrl: './list-mobile.component.html',
  styleUrls: ['./list-mobile.component.scss']
})
export class ListMobileComponent extends ListComponent implements OnInit {

  page: number = 0;
  moreData: boolean = true;

  ngOnInit(): void {
    this.loadQuotes();

    super.init();
  }

  loadQuotes() {
    this.page = 0;
    this.moreData = true;
    this.quotes = [];

    this.appendQuotes();
  }

  appendQuotes() {
    if (!this.moreData) return;

    this.quoteService.getList(this.filter, 'projectName', 'asc', this.page)
      .subscribe({
        next: (data) => {
          this.moreData = (data.length == settings.pageSize);
          data.forEach(d => this.quotes.push(d));
        },
        error: (error: string) => this.onError(error)
      });
  }

  onScroll() {
    this.page++;

    this.appendQuotes();
  }
}
